import script from "./customer-select-content.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-select-content.vue?vue&type=script&setup=true&lang=js"

import "./customer-select-content.vue?vue&type=style&index=0&id=0441544e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0441544e"]])

export default __exports__